module.exports = __webpack_public_path__ + "static/ProximaNova-Regular-e439d2f5096644b34258bd8be9f4ed8f.woff";